import type { IdUserDto } from '@/services/ws-permissions/src/main/resources/rest-api';

export enum UserDetailsTab {
  ADMINISTRATING_COMPANIES = 'administrating-companies',
}

export interface UserDetailsRouteParams {
  userId: IdUserDto;
}
